<div
  class="row journey-row"
  [class.active]="expanded && isSelectedVersion"
  [class.smart-actions]="journeyListUtils.isSmartActions"
  [ngClass]="{ deleted: journeyRecord.deleted }"
>
  @if (showCheckbox) {
  <div class="multi-select-container">
    @if (journeyRecord.id) {
    <div class="checkbox-container" (click)="stopProp($event)">
      <input type="checkbox" id="checkbox-{{ journeyRecord.id }}" />
      <label
        class="fake-checkbox"
        for="checkbox-{{ journeyRecord.id }}"
        (click)="journeyHasBeenChecked($event)"
      >
        <i
          class="fa fa-check"
          aria-hidden="true"
          [style.visibility]="isCheckedJourney ? 'visible' : 'hidden'"
        ></i>
      </label>
    </div>
    }
  </div>
  }
  <div
    [ngClass]="journeyListUtils.columnNameClassWidth"
    class="colw journey-name wrdbrk"
  >
    @if (showVersionToggle) {
    <div
      class="version-select-radio-btn"
      [class.active]="isSelectedVersion"
      [class.draft]="isDraft()"
      [class.complete]="isLive()"
      (click)="versionRadioToggled($event)"
    ></div>
    }

    <span>{{ journeyContent.name }}</span>
  </div>
  @if (isOutOfBoxExperienceEnabled) {
  <div
    id="journey-record-outcome-{{ index }}"
    class="colw colw-7 journey-data-field center wrdbrk"
  >
    <span
      class="ctrl-overflow"
      [matTooltip]="outcome_names"
      matTooltipPosition="above"
      >{{ outcome_names }}</span
    >
  </div>
  } @if (isOutOfBoxExperienceEnabled) {
  <div
    id="journey-record-experience-type-{{ index }}"
    class="colw colw-7 journey-data-field center wrdbrk"
  >
    <span
      class="ctrl-overflow"
      [matTooltip]="experience_type_names"
      matTooltipPosition="above"
      >{{ experience_type_names }}</span
    >
  </div>
  }
  <div
    id="journey-record-created-by-{{ index }}"
    [ngClass]="journeyListUtils.columnCreatedByClassWidth"
    class="colw journey-data-field center wrdbrk"
  >
    <span>{{ journeyRecord.created_by_name }}</span>
  </div>
  <div
    id="journey-record-product-group-{{ index }}"
    [ngClass]="journeyListUtils.columnProductGroupClassWidth"
    class="colw journey-data-field center wrdbrk"
  >
    <span>{{ journeyContent.product_group_internal_name }}</span>
  </div>
  <div
    id="journey-record-campaign-{{ index }}"
    [ngClass]="journeyListUtils.columnCampaignClassWidth"
    class="colw journey-data-field center wrdbrk"
  >
    <span>{{ journeyContent.campaign }}</span>
  </div>
  <div
    [ngClass]="journeyListUtils.columnDateCreatedClassWidth"
    class="colw journey-data-field center"
  >
    <span>{{ journeyRecord.created_at | date: 'shortDate' }}</span>
  </div>
  <div
    [ngClass]="journeyListUtils.columnDateModifiedClassWidth"
    class="colw journey-data-field center"
  >
    <span>{{ journeyContent.updated_at | date: 'shortDate' }}</span>
  </div>
  <!--  Look here for DIS-876 and DIS-877 -->
  <!-- Status column -->
  <div
    [ngClass]="journeyListUtils.columnStatusClassWidth"
    class="colw journey-data-field center journey-status-container"
  >
    @if (!showVersionToggle && !shouldSuppressDrafts()) {
    <span
      class="status status--draft"
      [class.status--active]="journeyRecord.draft"
      i18n="Label for experience in draft status"
      >Draft</span
    >
    <span
      class="status status--complete"
      [class.status--active]="journeyRecord.live"
      i18n="Label for experience in complete status"
      >Complete</span
    >
    } @if (!shouldSuppressDrafts() && showVersionToggle) {
    <span
      [ngClass]="{
        'status status--draft': true,
        'status--active': isDraft(),
        'status--hidden': isLive()
      }"
      i18n="Label for experience in draft status"
      >Draft</span
    >
    <span
      [ngClass]="{
        'status status--complete': true,
        'status--active': isLive(),
        'status--hidden': isDraft()
      }"
      i18n="Label for experience in complete status"
      >Complete</span
    >
    } @if (shouldSuppressDrafts() && !showVersionToggle) {
    <span
      class="status status--complete status--active launcher-mode"
      i18n="Label for experience in complete status"
      >Complete</span
    >
    }
  </div>

  <!-- Sparkles icon column -->
  @if (!journeyListUtils.isSmartActions) {
  <div class="colw journey-sparkles-icon-col center">
    @if (!showVersionToggle && !shouldSuppressDrafts()) { @if
    (journeyDraftAiGenerated && !journeyLiveAiGenerated) {
    <i
      [attr.data-testid]="'exp-' + journeyRecord.id + '-draft-sparkles'"
      class="fa-solid fa-sparkles fa-lg draft-sparkles collapsed-sparkles"
      matTooltip="Contains messages generated with AI"
      matTooltipPosition="above"
    ></i>
    } @if (journeyLiveAiGenerated) {
    <i
      [attr.data-testid]="'exp-' + journeyRecord.id + '-live-sparkles'"
      class="fa-solid fa-sparkles fa-lg live-sparkles collapsed-sparkles"
      matTooltip="Contains messages generated with AI"
      matTooltipPosition="above"
    ></i>
    } } @if (!shouldSuppressDrafts() && showVersionToggle) { @if
    (journeyDraftAiGenerated) {
    <i
      [attr.data-testid]="'exp-' + journeyRecord.id + '-draft-sparkles'"
      [ngClass]="{
        'status status--sparkles status--draft': true,
        'status--active': isDraft(),
        'status--none': isLive()
      }"
      class="fa-solid fa-sparkles fa-lg expanded-sparkles"
      matTooltip="Contains messages generated with AI"
      matTooltipPosition="above"
    ></i>
    } @if (journeyLiveAiGenerated) {
    <i
      [attr.data-testid]="'exp-' + journeyRecord.id + '-live-sparkles'"
      [ngClass]="{
        'status status--sparkles status--complete': true,
        'status--active': isLive(),
        'status--none': isDraft()
      }"
      class="fa-solid fa-sparkles fa-lg expanded-sparkles"
      style="padding-right: 15px"
      matTooltip="Contains messages generated with AI"
      matTooltipPosition="above"
    ></i>
    } }
  </div>
  }
  <!--  ^^^^^^^^   -->
  @if (busy) {
  <app-spinner class="colw journey-busy-icon"></app-spinner>
  } @if (!busy) {
  <div
    [ngClass]="journeyListUtils.columnActionIconsClassWidth"
    class="colw journey-button-row"
  >
    @if (isAllJourneysList() && showActions) { @if
    (showEditExperienceButton(journeyRecord)) {
    <i
      id="edit-icon-{{ journeyRecord.id.slice(0, 8) }}"
      routerLink="/cx-builder/experience-builder/{{ journeyRecord.id }}"
      class="fa fa-pencil"
      aria-hidden="true"
      matTooltip="Edit"
      matTooltipPosition="above"
    ></i>
    } @if (journeyPreviewable()) {
    <i
      id="preview-icon-{{ journeyRecord.id.slice(0, 8) }}"
      (click)="previewJourney()"
      class="fa-solid fa-file-magnifying-glass"
      aria-hidden="true"
      matTooltip="Preview"
      matTooltipPosition="above"
    ></i>
    } @if (showSendExperienceButton(journeyRecord)) {
    <i
      id="launch-icon-{{ journeyRecord.id.slice(0, 8) }}"
      routerLink="/launcher/launch/{{ journeyRecord.id }}"
      [class.disabled]="isDraft() && showActions"
      [class.hidden-icon]="!isAllJourneysList()"
      class="fa fa-paper-plane"
      aria-hidden="true"
      matTooltip="Send"
      matTooltipPosition="above"
    ></i>
    } @if (showExportExperienceButton(journeyRecord)) {
    <i
      id="export-icon-{{ journeyRecord.id.slice(0, 8) }}"
      [class.disabled]="
        disableExportExperienceButton(journeyRecord) && showActions
      "
      class="fa-solid fa-file-export"
      aria-hidden="true"
      matTooltip="Export"
      matTooltipPosition="above"
      (click)="exportExperience(journeyRecord, $event)"
    ></i>
    } @if (showArchiveButton(journeyRecord)) {
    <i
      id="delete-icon-{{ journeyRecord.id.slice(0, 8) }}"
      (click)="archiveJourney(journeyRecord, $event)"
      class="fa fa-archive"
      aria-hidden="true"
      matTooltip="Archive"
      matTooltipPosition="above"
    ></i>
    } @if (showUnarchiveButton(journeyRecord)) {
    <i
      id="restore-icon-{{ journeyRecord.id.slice(0, 8) }}"
      (click)="restoreJourney(journeyRecord, $event)"
      class="fa fa-undo"
      aria-hidden="true"
      matTooltip="Restore"
      matTooltipPosition="above"
    ></i>
    } } @if (selectionType==='customer-list-launch' && isLive() &&
    permissionService.checkPermissions(permissions.journey_trigger)) { @if
    (!journeyRecord.deleted) {
    <i
      aria-hidden="true"
      class="fa fa-paper-plane"
      routerLink="/launcher/launchforuser/{{
        activeRoute.snapshot.params['ccid']
      }}/launch/{{ journeyRecord.id }}"
    ></i>
    } } @if (showCopyBtn) {
    <button
      id="copy-btn-{{ journeyRecord.id.slice(0, 8) }}"
      class="btn btn-primary btn-copy-journey"
      (click)="copyJourney(journeyRecord, $event)"
    >
      <span class="btn-label" i18n="Label for copy-experience button"
        >copy</span
      >
      <span class="icon icon-right">
        <img src="assets/icons/copy-journey-sm.png" />
      </span>
    </button>
    } @if (launcherMode && !journeyRecord.deleted) {
    <button
      id="launch-btn-{{ journeyRecord.id.slice(0, 8) }}"
      class="btn btn-warning btn-launch"
      routerLink="/launcher/launch/{{ journeyRecord.id }}"
      [class.disabled]="isDraft() || !journeyRecord.live"
    >
      <span class="btn-label" i18n="Label for launch-experience button"
        >Launch</span
      >
      <span class="icon icon-right">
        <i class="fa fa-paper-plane" aria-hidden="true"></i>
      </span>
    </button>
    } @if (selectionType === 'CSR' && !showCheckbox) {
    <button
      id="select-fallback-btn-{{ journeyRecord.id.slice(0, 8) }}"
      class="btn btn-primary select-journey"
      (click)="selectFallbackJourney(journeyRecord, $event)"
    >
      <span class="btn-label" i18n="Label for select-experience button"
        >Select</span
      >
    </button>
    } @if (showActions) { @if (selectionType === 'smart-actions-experience') {
    <button
      class="btn btn-primary btn-select-journey"
      (click)="selectJourney(journeyRecord, $event)"
    >
      Select
    </button>
    } @if (!expanded) {
    <i
      class="fa fa-caret-right expand-collapse"
      matTooltip="Expand"
      matTooltipPosition="above"
    ></i>
    } @if (expanded) {
    <i
      class="fa fa-caret-down expand-collapse"
      matTooltip="Collapse"
      matTooltipPosition="above"
    ></i>
    } }
  </div>
  }
</div>
@if (journeyHasClientTriggerId && showCopyBtn) {
<p class="client-trigger-id-message">
  <i class="fa fa-exclamation-circle"></i>
  Client Trigger IDs will not appear in copied experiences.
</p>
}
